"use client";

import { Link } from "@/i18n/routing";
import { safeT } from "@/utils/safeT";
import { Box, Button, Container, Stack, Typography, useTheme } from "@mui/material";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const theme = useTheme();
  const t = useTranslations();
  useEffect(() => {
    // 에러 로그 출력 (디버깅용)
    console.error("Error occurred:", error);
  }, [error]);

  return (
    <Container
      maxWidth="md"
      disableGutters
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Stack alignItems="center" justifyContent="center" width="100%" spacing={2} px={2}>
        <Box
          sx={{
            width: 120,
            height: 120,
            backgroundImage: `url(${process.env.NEXT_PUBLIC_IMG_URL}/images/app/500.gif)`,
            backgroundSize: "100%",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            borderRadius: 50,
          }}
        />

        <Typography variant="h3" fontWeight="500" sx={{ mt: 2 }}>
          {" "}
          {safeT(t, "ui.message.genericError", { defaultMessage: "앗, 죄송합니다! 뭔가 잘못됐어요" })}
        </Typography>
        <Typography
          variant="subtitle1"
          color={theme.palette.text.secondary}
          sx={{ mt: 2, fontStyle: "italic", textWrap: "wrap" }}
        >
          {safeT(t, "ui.message.serverLost", {
            defaultMessage: "서버가 잠시 길을 잃은 것 같아요. 곧 다시 찾아드릴게요!",
          })}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mt: 4,
            fontSize: "1rem",
            px: 2,
            py: 0.5,
            borderRadius: 4,
            position: "relative",
            overflow: "hidden",
            "&:hover": {
              "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255, 255, 255, 0.2)",
                animation: "pulse 1.5s infinite",
              },
            },
          }}
          component={Link}
          href="/"
        >
          {safeT(t, "ui.button.safeReturnHome", {
            defaultMessage: "홈으로 안전 귀환",
          })}
        </Button>
      </Stack>
    </Container>
  );
}
